import React from "react";
import RowPayment from "./RowPayment";
import { GroupedPaymentList, PaymentDetail } from "../../types-interfaces/interfaces";
import { SelectedPayments } from "../../types-interfaces/types";

interface TableDataProps<T> extends React.HTMLAttributes<HTMLElement>{  
  data?: Array<PaymentDetail>
  isDetail?: boolean | undefined  
  onCheck?: (item: PaymentDetail | GroupedPaymentList, evt: React.MouseEvent<HTMLInputElement, MouseEvent>, isDetail: boolean | undefined, index: number, paymentCount: number) => void | undefined
  checkAll?: boolean | undefined
  index?: number | undefined
  selectionType?: "single" | "multiple" | undefined
  selectedItem?: T | undefined
  dataSelected: Array<SelectedPayments>
}

class TableData<T> extends React.Component<TableDataProps<T>> {
  isChecked(index: number) {
    try {
      const isChecked = this.props.dataSelected[index] !== undefined ? true : false;
      return isChecked;
    } catch (err) {
      return false;
    }
  }

  render() {
    return (     
      <div className={this.props.className}>        
        {this.props.data?.map((row,index) =>
          <RowPayment
            key={'r' + index}
            className={this.props.className + '-row'}
            rowData={row}
            isDetail={this.props.isDetail}
            onCheck={this.props.onCheck}
            checkAll={this.props.checkAll}
            index={row.index}
            selectionType={this.props.selectionType}
            uncheck={(this.props.selectedItem !== row) ? "true" : undefined}
            checked={this.isChecked(row.index)}
            paymentCount={this.props.data?.length || 0}
          />
        )}        
      </div>     
    );
  }
}

export default TableData;